import { useQuery } from '@tanstack/react-query';
import { reportsApi } from '../services/api';

export const useMerchantSearch = (filters = {}) => {
  return useQuery({
    queryKey: ['merchantSearch', filters],
    queryFn: () => reportsApi.searchMerchantNetwork(filters),
    staleTime: 2 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};

export const useMerchantFilterOptions = (currentFilters = {}) => {
  return useQuery({
    queryKey: ['merchantFilterOptions', currentFilters],
    queryFn: () => reportsApi.getMerchantFilterOptions(currentFilters),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
